export enum AttachmentTypeEnum {
  IMAGE = "image",
  PDF = "pdf",
  PRESENTATION = "presentation", // Google-doc-viewable URL (iframe) → ModalGoogleDocViewer
  PRESENTATION_PAGES = "presentation-pages", // caller-assembled PresentationPage[] → ModalPresentationViewer
  VIDEO = "video",
  ZIP = "zip",
}
